module.exports = __webpack_public_path__ + "static/media/Firebase.cbba4418.png";